import Flickity from 'flickity';

const selectors = {
  mobileSlider: '.product-grid--slider',
  flickityInitialized: 'flickity-enabled',
};

class GridSlider {
  constructor(container) {
    this.container = container;
    this.mobileSlider = this.container.querySelector(selectors.mobileSlider);
    this.flkty = null;

    this.init();
  }

  init() {
    this.mobileCheck();
    document.addEventListener('theme:resize', this.mobileCheck.bind(this));
  }

  initMobileSlider() {
    if (this.mobileSlider && !this.mobileSlider.classList.contains(selectors.flickityInitialized)) {
      this.flkty = new Flickity(this.mobileSlider, {
        contain: true,
        pageDots: false,
        arrowShape:
          'M4.068 18.649l15.466 16.105c.31.283.466.629.466 1.039 0 .41-.155.77-.466 1.08a1.412 1.412 0 0 1-1.038.424c-.41 0-.756-.141-1.038-.424L.466 19.708A1.373 1.373 0 0 1 0 18.648c0-.423.155-.776.466-1.059L17.458.424A1.412 1.412 0 0 1 18.496 0c.41 0 .755.141 1.038.424.31.282.466.636.466 1.06 0 .423-.155.776-.466 1.059L4.068 18.649z',
      });
    }
  }

  destroyMobileSlider() {
    if (this.flkty && typeof this.flkty.destroy === 'function') {
      this.flkty.destroy();
    }
  }

  mobileCheck() {
    const isMobile = window.innerWidth < window.theme.sizes.small;
    if (isMobile) {
      this.initMobileSlider();
    } else {
      this.destroyMobileSlider();
    }
  }
}
const gridSlider = {
  onLoad() {
    new GridSlider(this.container);
  },
};

export default gridSlider;
